import { useEffect, useState } from "react";
import styled from "styled-components";
import { ReactComponent as RightBracket } from "../Images/right_bracket.svg";
import { ReactComponent as RightBracketDouble } from "../Images/Right_bracket_double.svg";
import "../Styles/global.css";

const PaginationForMiniList = ({ totalPages, currentPage, onPageChange }) => {
  const [current, setCurrent] = useState(currentPage);

  useEffect(() => {
    setCurrent(currentPage);
  }, [currentPage]);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrent(page);
    onPageChange(page);
  };

  const renderPageBtn = () => {
    let startPage = Math.max(1, current - 2);
    let endPage = Math.min(totalPages, current + 2);

    const pages = [];

    if (totalPages > 4) {
      if (current <= 3) {
        startPage = 1;
        endPage = 4;
      } else if (current + 2 >= totalPages) {
        startPage = totalPages - 4;
        endPage = totalPages;
      } else {
        startPage = current - 2;
        endPage = current + 2;
      }
    }

    if (startPage > 2) {
      pages.push(
        <PagingBtn key={1} onClick={() => handlePageChange(1)}>
          1
        </PagingBtn>
      );
      pages.push(
        <PagingBtn key="ellipsis1" disabled>
          ...
        </PagingBtn>
      );
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <PagingBtn
          key={i}
          $isCurrent={i === current}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </PagingBtn>
      );
    }

    if (endPage < totalPages - 1) {
      pages.push(
        <PagingBtn key="ellipsis2" disabled>
          ...
        </PagingBtn>
      );
      pages.push(
        <PagingBtn
          key={totalPages}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </PagingBtn>
      );
    }

    return pages;
  };

  const handlePrevious = () => {
    if (current > 1) handlePageChange(current - 1);
  };
  const handleNext = () => {
    if (current < totalPages) handlePageChange(current + 1);
  };

  const handleDoubleBack = () => {
    handlePageChange(Math.max(1, current - 5));
  };
  const handleDoubleForward = () => {
    handlePageChange(Math.min(totalPages, current + 5));
  };

  return (
    <PaginationWrapper>
      <PagingBar>
        {/* << 버튼 */}
        {totalPages > 5 && current > 5 && (
          <PagingBtn onClick={handleDoubleBack}>
            <RightBracketDouble
              style={{ transform: "rotate(180deg)" }}
              stroke="#6d6d6d"
            />
          </PagingBtn>
        )}
        {/* < 버튼 */}
        {current > 1 && (
          <PagingBtn onClick={handlePrevious}>
            <RightBracket
              style={{ transform: "rotate(180deg)" }}
              stroke="#6d6d6d"
            />
          </PagingBtn>
        )}

        {/* 페이지 버튼들 */}
        <PageNumberWrapper>{renderPageBtn()}</PageNumberWrapper>

        {/* > 버튼 */}
        {current < totalPages && (
          <PagingBtn onClick={handleNext}>
            <RightBracket stroke="#6d6d6d" />
          </PagingBtn>
        )}
        {/* >> 버튼 */}
        {totalPages > 5 && current < totalPages - 4 && (
          <PagingBtn onClick={handleDoubleForward}>
            <RightBracketDouble stroke="#6d6d6d" />
          </PagingBtn>
        )}
      </PagingBar>
    </PaginationWrapper>
  );
};

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const PagingBar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const PageNumberWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-grow: 1;
`;

const PagingBtn = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "notoSans-medium";
  font-size: 18px;
  color: ${(props) => (props.$isCurrent ? "#1167ed" : "#6d6d6d")};
  background-color: ${(props) =>
    props.$isCurrent ? "#DBE8FD" : "transparent"};
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
`;

export default PaginationForMiniList;
